<template>
  <div class="fill-height grey-bg">
    <GameTopbar score=" " :clue="false"/>

    <PinchZoom class="fill-height">
      <v-main class="fill-height">
        <div class="fill-height d-flex flex-column align-center justify-center">
          <slot />
        </div>
      </v-main>
    </PinchZoom>
  </div>
</template>

<style scoped>
>>> .pinch-zoom-wrapper {
  background-color: transparent !important;
}
</style>

<script>
import PinchZoom from 'vue-pinch-zoom';

import GameTopbar from '@/components/navigation/GameTopbar.vue';

export default {
  name: 'GameLayout',
  components: {
    PinchZoom,
    GameTopbar,
  },
};
</script>
